export const procurementEvents = {
  openMyPurchaseRequests: 'Go to My purchase requests',
  openPurchaseRequests: 'Go to Purchase requests',
  openPurchaseOrders: 'Go to Purchase Orders',
  openVendors: 'Go to Vendors',
  viewPurchaseRequestDetail: 'View purchase request detail',
  viewPurchaseOrderDetail: 'View purchase order detail',
  clickNewPurchaseRequest: 'Create Purchase request',
  goToVendorStepOnNewPurchaseRequestWizard: 'Create Purchase request 2',
  goToAttachmentsStepOnNewPurchaseRequestWizard: 'Create Purchase request 3',
  submitNewPurchaseRequest: 'Create Purchase request Submit',
  clickNewVendor: 'Create Vendor',
  submitNewVendor: 'Create Vendor Submit',
  approvePurchaseRequest: 'Approve purchase request',
  rejectPurchaseRequest: 'Reject purchase request',
}
